import Vue from 'vue'
import Vuex from 'vuex'

import AuthenticationModule from '@/store/modules/authentication'
import ArtworkTypes from '@/store/modules/codebook/artworkTypes'
import Authors from '@/store/modules/codebook/authors'
import Locations from '@/store/modules/codebook/locations'
import Styles from '@/store/modules/codebook/styles'
import Techniques from '@/store/modules/codebook/techniques'
import Themes from '@/store/modules/codebook/themes'
import Dimensions from '@/store/modules/codebook/dimensions'
import PriceTypes from '@/store/modules/codebook/priceTypes'
import Materials from '@/store/modules/codebook/materials'
import Currencies from '@/store/modules/codebook/currencies'

import BasicUserInfo from '@/store/modules/user/basicUserInfo'
import LocalSettings from '@/store/modules/user/localSettings'

import ExportBoxes from '@/store/modules/export/exportBoxes'
import Exports from '@/store/modules/export/exports'

import Artworks from '@/store/modules/artwork/artworks'

import CollectionContext from '@/store/modules/collection/collectionContext'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    authentication: AuthenticationModule,
    artworkTypes: ArtworkTypes,
    authors: Authors,
    locations: Locations,
    styles: Styles,
    techniques: Techniques,
    themes: Themes,
    materials: Materials,
    currencies: Currencies,
    basicUserInfo: BasicUserInfo,
    localSettings: LocalSettings,
    exportBoxes: ExportBoxes,
    exports: Exports,
    dimensions: Dimensions,
    priceTypes: PriceTypes,
    artworks: Artworks,
    collectionContext: CollectionContext
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js